import { useQuery } from '@tanstack/react-query';
import { useRoadmapApi } from './api-context';

export function useRoadmap() {
  const api = useRoadmapApi();
  return useQuery({
    queryKey: ['roadmap'],
    queryFn: ({ signal }) => api.get(signal),
    staleTime: 5 * 60 * 1000,
  });
}
